
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/article/[article]",
      function () {
        return require("private-next-pages/blog/article/[article].jsx");
      }
    ]);
  